import React from 'react';
import { ResultCard } from '../../components/ResultCard';
import { formatQuantity } from '../../../../utils/inventoryLabels';
import {
  orderDone,
  orderRefOf,
  routeResultTitle,
} from '../../../../features/operatorPicking/operatorPickingRouteUtils';

const Row = ({ testId, orderId, title, text }) => (
  <li data-testid={testId} data-order-id={orderId} className="rounded-2xl border border-border p-3">
    <p className="text-base font-bold text-ninja-dark dark:text-white">{title}</p>
    <p className="text-sm text-text-secondary">{text}</p>
  </li>
);

/**
 * The route walked: how many orders came out picked, those that did not and
 * why — left out of the route, or with lines nothing could be planned for —,
 * and, for a batch, that it is separated by order at packing. Where to go
 * next is the screen's primary.
 *
 * @param {object} props
 * @param {object} props.route
 */
export const RouteResult = ({ route }) => {
  const orders = route.orders || [];
  const incomplete = orders.filter((order) => !orderDone(order));
  const skipped = route.skipped || [];
  const unplannable = route.unplannable || [];
  const refOf = (orderId) => orderRefOf(orders.find((order) => order.id === orderId) || { id: orderId });
  const whole = orders.length > 0 && incomplete.length === 0 && skipped.length === 0;

  return (
    <ResultCard title={routeResultTitle(route)} tone={whole ? 'success' : 'warning'} testId="route-done">
      {incomplete.length > 0 && (
        <ul className="space-y-2" aria-label="Pedidos incompletos">
          {incomplete.map((order) => (
            <Row
              key={order.id}
              testId="route-incomplete-order"
              orderId={order.id}
              title={orderRefOf(order)}
              text={`${formatQuantity(order.picked)} de ${formatQuantity(order.units)} un pickeadas`}
            />
          ))}
        </ul>
      )}
      {unplannable.length > 0 && (
        <ul className="space-y-2" aria-label="Sin stock para la ruta">
          {unplannable.map((line) => (
            <Row
              key={`${line.order_id}:${line.line_id}`}
              testId="route-unplannable"
              orderId={line.order_id}
              title={`${refOf(line.order_id)} · ${line.sku}`}
              text={`Faltan ${formatQuantity(line.missing)} un: no hay stock donde tomarlas. Avisa a tu supervisor.`}
            />
          ))}
        </ul>
      )}
      {skipped.length > 0 && (
        <ul className="space-y-2" aria-label="Fuera de la ruta">
          {skipped.map((order) => (
            <Row
              key={order.order_id}
              testId="route-skipped-order"
              orderId={order.order_id}
              title={orderRefOf(order)}
              text={`Quedó fuera de la ruta: ${order.reason}`}
            />
          ))}
        </ul>
      )}
      {orders.length > 1 && (
        <p data-testid="route-separate" className="text-base font-semibold text-ninja-dark dark:text-white">
          Separa por pedido al empacar.
        </p>
      )}
    </ResultCard>
  );
};
